import { License_Key } from 'src/app/app-constants';

export const environment = {
    production: true,
    cloudinary: {
        cloud_name: 'pos-uat',
        company_preset: 'pos-uat',
    },
    defualtThumbnail: 'pos-uat/app-images/default-img.jpg',
    logging: true,
    showNetworkIssue: true,
    orgLogo: 'https://res.cloudinary.com/pos-uat/image/upload/c_fill,g_face,w_240,h_160/',
    restUrl: window.location.protocol + '//api.dev.eretailpoint.com',

    organizationBaseUrl: window.location.protocol + '//d1exa5dclpzcx0.cloudfront.net',
    loggerBaseUrl: window.location.protocol + '//d18o055jxsy5u9.cloudfront.net',
    inventoryBaseUrl: window.location.protocol + '//d278zg4wjvt2kv.cloudfront.net',
    invoiceBaseURL: window.location.protocol + '//d2f6f23meh4jus.cloudfront.net',
    catalogBaseUrl: window.location.protocol + '//d3vd9wdihvtc79.cloudfront.net',
    salesReportereBaseURL: window.location.protocol + '//d1ug0fldeogf41.cloudfront.net',
    accountBaseUrl: window.location.protocol + '//d3otxdvieudc3c.cloudfront.net',
    receiptPrinterServerUrl: 'http://localhost:3001',
    AgGridLicenseKey: License_Key.AgGridLicenseKey,
    cognito: {
        authenticationFlowType: 'USER_PASSWORD_AUTH',
        region: 'us-west-2',
        userPoolId: 'us-west-2_b5TWOIGmj',
        userPoolClientId: '2tp875v98bkrd2qb93osolvqai',
        mandatorySignIn: true,

        /*
        cookieStorage: {
            domain: '',
            path: '/',
            expires: 365,
            sameSite: "lax",
            secure: false
        },

        storage: MyStorage,
        authenticationFlowType: 'USER_PASSWORD_AUTH',
        clientMetadata: { myCustomKey: 'myCustomValue' },
        oauth: {
            domain: '',
            scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: '',
            redirectSignOut: '',
            responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
        }
        */
    },
    events: {
        endpoint: window.location.protocol + '//bm55mu7dgjg45ivdvoqass7av4.appsync-api.us-west-2.amazonaws.com/event',
        region: 'us-west-2',
        defaultAuthMode: 'apiKey',
        apiKey: 'da2-foeibja34vdhjdhv25wmzwthoq',
        appsyncnamespace: 'msvc-invoices-track',
    },
};
